module.exports = __webpack_public_path__ + "img/city_bg.c2c58c7b.jpg";